import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// campfire
import { AppointmentsService, LoggerService } from '@campfire-nx/api';

import { APPOINTMENT_BOOKING_TOPICS } from '@open-portal-app/help/constants/help.constants';

// TODO: Change this based on new API for assisted request
export interface IRequestDetails {
  topic: string;
  option: string;
  entity?: string | null;
  entity_ref?: string | null;
  raptorSource?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  details!: IRequestDetails;

  constructor(
    private router: Router,
    private appointmentsService: AppointmentsService,
    private loggerService: LoggerService
  ) { }


  start(requestDetails: IRequestDetails) {
    this.details = requestDetails;
    this.router.navigate(['/request'], { state: requestDetails || APPOINTMENT_BOOKING_TOPICS.contactUs, replaceUrl: true });
  }

  createRequest(payload: any) {
    return this.appointmentsService.createRequest(payload)
      .then(response => response)
      .catch((error) => {
        this.loggerService.error('RequestService', 'createAppointment', error);
        return error;
      });
  }
}
